import { getCurrentInstance } from '@vue/composition-api'

export const useI18n = () => {
  const vm = getCurrentInstance()?.proxy
  return {
    $t: vm!.$t.bind(vm),
    $tc: vm!.$tc.bind(vm),
    $te: vm!.$te.bind(vm),
    $d: vm!.$d.bind(vm),
    $n: vm!.$n.bind(vm),
    $i18n: vm!.$i18n,
  }
}

export type useI18nType = ReturnType<typeof useI18n>
